import { toast } from 'react-toastify';
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { captureNonApiError } from './capture-non-api-error';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache({
    onError: captureNonApiError,
  }),
  queryCache: new QueryCache({
    onError: (_error, query) => {
      // Only fires for background refetch failures — data was already in cache
      // Note: axios interceptor also toasts on these; known double-toast, deferred to Phase C
      if (query.state.data !== undefined && !query.meta?.silent) {
        toast.error('Failed to refresh data. Please reload the page.');
      }
    },
  }),
});
